import * as React from "react";
import { useLocation } from 'react-router-dom';

export function useQueryString() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export function modQueryPageNum(queryParams, pageNum) {
  if (queryParams.has('page')) {
    queryParams.set('page', pageNum);
  }
  else {
    queryParams.append('page', pageNum);
  }
}

export function getQueryPageNum(queryParams) {
  const queryPageNum = queryParams.get("page");
  const pageNum = queryPageNum ? parseInt(queryPageNum, 10) || 1 : 1;
  return pageNum;
}